import { useStore } from '../store/store';
import { convertToContentfulLocale, getContentfulLocaleFromLanguage } from '../utils/tools';

/**
 * Resolves the Contentful locale from the active region and the label-language
 * override, which the URL does not carry.
 * @param locale - Region locale from the URL, e.g. 'de-de'
 * @param language - Label-language override; null means use the region's own language
 * @returns Locale in Contentful format like 'de-DE'
 */
export const deriveContentfulLocale = (locale: string, language: string | null): string =>
  language ? getContentfulLocaleFromLanguage(language) : convertToContentfulLocale(locale);

/**
 * Contentful locale for the active session, for passing to embedded packages that
 * fetch their own labels but have no access to this app's store.
 */
export const useContentfulLocale = (): string => {
  const locale = useStore((state) => state.locale);
  const language = useStore((state) => state.language);

  return deriveContentfulLocale(locale, language);
};
